export default {
  home: {
    title: 'USFans Spreadsheet — Znajdź, porównaj i przeglądaj zasoby USFans',
    metaDescription: 'Przeglądaj zasoby USFans Spreadsheet, kategorie produktów, poradniki zakupowe, informacje o wysyłce i wskazówki bezpieczeństwa — w jednym, wielojęzycznym centrum.',
    hero: {
      badge: 'Niezależne centrum zasobów',
      h1: 'USFans Spreadsheet — Znajdź, porównaj i przeglądaj zasoby USFans',
      subtitle: 'Przeglądaj najnowsze zasoby USFans Spreadsheet, poradniki produktowe, wskazówki zakupowe, informacje o wysyłce i zasoby bezpieczeństwa — wszystko w jednym, wygodnym miejscu.',
      trust1: 'Uporządkowane zasoby',
      trust2: 'Regularne aktualizacje',
      trust3: 'Poradniki wielojęzyczne',
      trust4: 'Informacje o bezpieczeństwie',
      dropdownLabel: 'Wybierz kategorię',
      dropdownPlaceholder: 'Wybierz kategorię produktów',
    },
    why: {
      title: 'Dlaczego warto korzystać z USFans Spreadsheet?',
      text: 'Znalezienie przydatnych zasobów USFans bywa trudne, gdy informacje są rozproszone po różnych stronach, społecznościach i wpisach. Naszym celem jest uporządkowanie najbardziej przydatnych informacji o USFans Spreadsheet w czytelne kategorie, praktyczne poradniki i zrozumiałe porównania.',
    },
    categories: {
      title: 'Przeglądaj kategorie produktów',
      subtitle: 'Przejdź od razu do potrzebnej kategorii na głównej stronie.',
      viewAll: 'Zobacz wszystkie kategorie',
    },
    topics: {
      title: 'Popularne tematy USFans',
      subtitle: 'Tematy, których użytkownicy szukają najczęściej.',
      topic1Title: 'USFans Spreadsheet',
      topic1Desc: 'Pełny przegląd arkusza, kategorii i linków.',
      topic2Title: 'Recenzja USFans',
      topic2Desc: 'Co warto wiedzieć przed skorzystaniem z USFans — plusy i minusy.',
      topic3Title: 'Koszt wysyłki USFans',
      topic3Desc: 'Poznaj stawki, czas dostawy i sposoby oszczędzania.',
      topic4Title: 'Kupon USFans',
      topic4Desc: 'Jak znaleźć aktualne kupony i oferty rabatowe.',
      topic5Title: 'Kod rabatowy USFans',
      topic5Desc: 'Praktyczne spojrzenie na to, gdzie pojawiają się kody rabatowe.',
      topic6Title: 'Magazyn USFans',
      topic6Desc: 'Jak działa proces magazynowania, przechowywania i kontroli jakości.',
      topic7Title: 'Czy USFans jest legalne',
      topic7Desc: 'Kontrole bezpieczeństwa i to, co zweryfikować przed zakupem.',
    },
    guides: {
      title: 'Najnowsze poradniki',
      subtitle: 'Oryginalne, szczegółowe artykuły, które pomogą Ci lepiej korzystać z USFans Spreadsheet.',
      readMore: 'Czytaj poradnik',
      articleTitle: 'Czym jest USFans Spreadsheet? Kompletny przewodnik',
      articleCategory: 'Poradnik',
      articleReadingTime: '6 min czytania',
      articleSummary: 'Przejrzysty, oryginalny przegląd tego, jak działa USFans Spreadsheet, jak przeglądać kategorie, porównywać produkty i robić zakupy z pewnością.',
    },
    pillars: {
      title: 'Artykuły filarowe',
      subtitle: 'Szczegółowe poradniki o najważniejszych tematach, regularnie aktualizowane.',
      label: 'Poradnik',
      minRead: 'min czytania',
      readMore: 'Czytaj poradnik',
      items: {
        spreadsheetGuide: { title: 'Czym jest USFans Spreadsheet?', summary: 'Przejrzysty przegląd tego, czym jest arkusz i jak jest zorganizowany.' },
        howToUse: { title: 'Jak korzystać z USFans Spreadsheet', summary: 'Wskazówki krok po kroku do przeglądania kategorii i szybkiego znajdowania produktów.' },
        directory: { title: 'Katalog USFans Spreadsheet', summary: 'Jak katalog grupuje produkty i linki dla łatwiejszego przeglądania.' },
        review: { title: 'Recenzja USFans: plusy i minusy', summary: 'Wyważone spojrzenie na mocne strony i rzeczy, na które warto uważać.' },
        shippingCost: { title: 'Przewodnik po kosztach wysyłki USFans', summary: 'Poznaj stawki, czas dostawy i praktyczne sposoby oszczędzania.' },
        warehouse: { title: 'Przewodnik po magazynie USFans', summary: 'Jak działa przechowywanie, kontrola jakości i wysyłka.' },
        coupon: { title: 'Przewodnik po kuponach i kodach USFans', summary: 'Gdzie znaleźć aktualne kupony i kody rabatowe.' },
        legit: { title: 'Czy USFans jest legalne?', summary: 'Kontrole bezpieczeństwa i to, co zweryfikować przed zakupem.' },
        buyingGuide: { title: 'Poradnik zakupowy USFans', summary: 'Praktyczna lista kontrolna dla sprawnego i świadomego zakupu.' },
        safety: { title: 'Przewodnik bezpieczeństwa USFans', summary: 'Jak weryfikować linki, płatności i zachować bezpieczeństwo online.' },
      },
    },
    safety: {
      title: 'Korzystaj z zasobów USFans bezpieczniej',
      text: 'Zawsze weryfikuj linki, aktualne ceny, informacje o wysyłce i dane sprzedawcy przed dokonaniem zakupu. Nigdy nie udostępniaj haseł, kodów uwierzytelniających ani poufnych danych płatniczych nieznanym stronom.',
      cta: 'Czytaj poradnik bezpieczeństwa',
      check1: 'Zweryfikuj domenę',
      check2: 'Sprawdź HTTPS',
      check3: 'Nigdy nie udostępniaj haseł',
      check4: 'Nigdy nie udostępniaj kodów weryfikacyjnych',
    },
    faq: {
      title: 'Często zadawane pytania',
      subtitle: 'Szybkie odpowiedzi na częste pytania o USFans Spreadsheet.',
      q1: 'Czym jest USFans Spreadsheet?',
      a1: 'USFans Spreadsheet to uporządkowana lista amerykańskich produktów modowych i streetwearowych oraz linków zakupowych, pogrupowana w czytelne kategorie, takie jak buty, bluzy, koszulki i akcesoria, aby szybciej znaleźć to, czego potrzebujesz.',
      q2: 'Czy USFans Spreadsheet jest darmowy?',
      a2: 'Przeglądanie kategorii i poradników jest bezpłatne. Zawsze weryfikuj aktualne ceny, szczegóły wysyłki i informacje o sprzedawcy na głównej stronie przed dokonaniem zakupu.',
      q3: 'Jak znaleźć konkretny produkt?',
      a3: 'Użyj rozwijanej listy kategorii lub przycisków kategorii na tej stronie, aby przejść od razu do odpowiedniej sekcji głównej strony.',
      q4: 'Czy USFans jest legalne?',
      a4: 'Zawsze zalecamy weryfikację linków, sprawdzenie HTTPS oraz samodzielne potwierdzenie danych sprzedawcy i płatności przed zakupem. Traktuj nieznane strony z ostrożnością.',
      q5: 'Co sprawdzić przed zakupem?',
      a5: 'Sprawdź aktualne ceny, koszty i czas wysyłki, zasady zwrotów oraz dane sprzedawcy. Informacje mogą się zmieniać, więc potwierdź najnowsze szczegóły na głównej stronie.',
      q6: 'Jak często informacje są aktualizowane?',
      a6: 'Staramy się aktualizować poradniki i kategorie, ale zawsze potwierdzaj bieżące oferty i ceny na głównej stronie przed zakupem.',
    },
    final: {
      title: 'Gotowy, aby przeglądać zasoby USFans Spreadsheet?',
      text: 'Zacznij od centrum USFans Spreadsheet i odkrywaj poradniki, porównania, recenzje, informacje o wysyłce i praktyczne zasoby.',
    },
  },
};